import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { X, Check } from "lucide-react";

export default function CopyTradeModal({ leader, onClose, onSuccess }) {
  const [amount, setAmount] = useState(10);
  const [maxDailyLoss, setMaxDailyLoss] = useState("");
  const [stopCopyOnLoss, setStopCopyOnLoss] = useState("");
  const [loading, setLoading] = useState(false);

  const handleFollow = async () => {
    if (amount < 1) {
      toast.error("Miktar en az $1 olmalıdır.");
      return;
    }
    setLoading(true);
    try {
      const body = { amount_per_trade: Number(amount) };
      if (maxDailyLoss) body.max_daily_loss = Number(maxDailyLoss);
      if (stopCopyOnLoss) body.stop_copy_on_loss = Number(stopCopyOnLoss);
      await api.post(`/social/follow/${leader.id}`, body);
      toast.success(`${leader.display_name} başarıyla takip edilmeye başlandı!`);
      if (onSuccess) onSuccess();
      onClose();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
      <div className="bg-panel border border-line rounded-md w-full max-w-sm overflow-hidden">
        <div className="flex items-center justify-between p-4 border-b border-subtle">
          <h2 className="text-sm font-bold uppercase tracking-widest text-dim">Lideri Kopyala</h2>
          <button onClick={onClose} className="text-dim hover:text-white transition-colors">
            <X className="w-5 h-5" />
          </button>
        </div>
        
        <div className="p-6">
          <div className="mb-4">
            <div className="text-xs text-dim uppercase tracking-widest mb-1">Lider</div>
            <div className="font-mono text-lg">{leader.display_name}</div>
          </div>
          
          <div className="mb-6">
            <label className="block text-xs text-dim uppercase tracking-widest mb-2">Her İşlem İçin Kopya Miktarı ($)</label>
            <input 
              type="number" 
              value={amount} 
              onChange={(e) => setAmount(e.target.value)}
              className="w-full bg-app border border-subtle rounded-sm px-4 py-2 font-mono text-lg focus:border-buy focus:outline-none transition-colors"
              min="1"
            />
            <div className="text-[10px] text-muted mt-2">
              Lider yeni bir işlem açtığında, otomatik olarak bu miktar ile sizin hesabınızda da açılır.
            </div>
          </div>

          {/* Risk Controls */}
          <div className="mb-6 space-y-3">
            <div className="text-xs text-dim uppercase tracking-widest mb-1">Risk Kontrolleri (opsiyonel)</div>
            <div>
              <label className="block text-[10px] text-dim mb-1">Maks. Günlük Kayıp ($)</label>
              <input type="number" value={maxDailyLoss} onChange={(e) => setMaxDailyLoss(e.target.value)}
                placeholder="Örn: 100" className="w-full bg-app border border-subtle rounded-sm px-3 py-2 font-mono text-sm focus:border-buy focus:outline-none" />
            </div>
            <div>
              <label className="block text-[10px] text-dim mb-1">Kayıpta Kopyalama Durdurma (%)</label>
              <input type="number" value={stopCopyOnLoss} onChange={(e) => setStopCopyOnLoss(e.target.value)}
                placeholder="Örn: 20" min="0" max="100" className="w-full bg-app border border-subtle rounded-sm px-3 py-2 font-mono text-sm focus:border-buy focus:outline-none" />
            </div>
          </div>
          
          <button 
            onClick={handleFollow}
            disabled={loading}
            className="w-full bg-buy text-black font-bold uppercase tracking-widest py-3 rounded-sm flex items-center justify-center gap-2 hover:bg-emerald-400 transition-colors disabled:opacity-50"
          >
            {loading ? "İşleniyor..." : <><Check className="w-4 h-4"/> Kopyalamayı Başlat</>}
          </button>
        </div>
      </div>
    </div>
  );
}
